import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { useDashboard } from './useDashboard';
import { fetchJSON, AuthError } from '@/api/client';

export interface HealthScorePoint { timestamp: string; score: number; }

export function useHealthScore(hours = 24) {
  const { token, logout } = useAuth();
  const { refreshKey } = useDashboard();
  const [scores, setScores] = useState<HealthScorePoint[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;
    fetchJSON<{ scores?: HealthScorePoint[] }>(`/api/dashboard/health-score?hours=${hours}`, token)
      .then((d) => { if (!cancelled) { setScores(d.scores || []); setLoading(false); } })
      .catch((e) => {
        if (e instanceof AuthError) { logout(); return; }
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [token, hours, refreshKey, logout]);

  return { scores, loading };
}
